import type { UserRepository } from "../../domain/repositories/user-repository";
import { AppError } from "../../shared/utils/error-handler";
import type { LandingUserInfoResponse } from "../types/shared";
import type { UpdateUserInfoRequest } from "../types/user";

export class UserUseCase {
  constructor(private userRepository: UserRepository) {}

  async getUserInfo(): Promise<LandingUserInfoResponse> {
    try {
      const user = await this.userRepository.getUserInfo();
      if (!user) {
        throw new AppError("사용자를 찾을 수 없습니다.", "USER_NOT_FOUND");
      }
      return user;
    } catch (error) {
      throw new AppError(
        String(error) || "사용자 정보를 불러오는데 실패했습니다.",
        "USER_FETCH_FAILED",
        error,
      );
    }
  }

  async updateUserInfo(request: UpdateUserInfoRequest): Promise<LandingUserInfoResponse> {
    try {
      return await this.userRepository.updateUserInfo(request);
    } catch (error) {
      throw new AppError(
        String(error) || "사용자 정보 업데이트에 실패했습니다.",
        "USER_UPDATE_FAILED",
        error,
      );
    }
  }
}
